import actionTypes from './actions/actionTypes'

const {
  REQUEST_ROOMS,
  REQUEST_PREVIOUS_ROOMS,
  RECEIVE_UPCOMING_ROOMS,
  SERVER_ERROR_OCURED,
  RECEIVE_PREVIOUS_ROOMS,
  SELECT_CONFERENCE,
  REQUEST_CONFERENCE_DETAILS,
  RECEIVE_CONFERENCE_DETAILS,
  REQUEST_PARTICIPANT_LIST,
  RECEIVE_PARTICIPANT_LIST,
  REQUEST_RECORD_LIST,
  RECEIVE_RECORD_LIST,
  SCHEDULE_SUBMITTED
} = actionTypes

const roomReducer = (
  state = {
    isFetchingRooms: false,
    isFetchingPreviousRooms: false,
    isFetchingParticipantList: false,
    isFetchingRecordList: false,
    upcoming: false,
    upCommingRooms: [],
    previousRooms: [],
    participants: [],
    recordings: [],
    serverError: false,
    selectConferenceId: null,
    isFetchingConferenceDetails: false,
    conferenceDetails: {},
    scheduleUpdated: false,
    startDate: {}
  },
  action
) => {
  switch (action.type) {
    case REQUEST_ROOMS:
      return Object.assign({}, state, {
        isFetchingRooms: true
      })
    case REQUEST_PREVIOUS_ROOMS:
      return Object.assign({}, state, {
        isFetchingPreviousRooms: true
      })
    case RECEIVE_UPCOMING_ROOMS:
      return Object.assign({}, state, {
        isFetchingRooms: false,
        upCommingRooms: action.upCommingRooms,
        upcoming: true
      })
    case RECEIVE_PREVIOUS_ROOMS:
      return Object.assign({}, state, {
        isFetchingPreviousRooms: false,
        previousRooms: action.previousRooms,
        upcoming: false
      })
    case REQUEST_PARTICIPANT_LIST:
      return Object.assign({}, state, {
        isFetchingParticipantList: true
      })
    case RECEIVE_PARTICIPANT_LIST:
      return Object.assign({}, state, {
        isFetchingParticipantList: false,
        participants: action.participants
      })
    case REQUEST_RECORD_LIST:
      return Object.assign({}, state, {
        isFetchingRecordList: true
      })
    case RECEIVE_RECORD_LIST:
      return Object.assign({}, state, {
        isFetchingRecordList: false,
        recordings: action.recordings
      })
    case SELECT_CONFERENCE:
      return Object.assign({}, state, {
        selectConferenceId: action.conferenceId
      })
    case REQUEST_CONFERENCE_DETAILS:
      return Object.assign({}, state, {
        isFetchingConferenceDetails: true
      })
    case RECEIVE_CONFERENCE_DETAILS:
      return Object.assign({}, state, {
        isFetchingConferenceDetails: false,
        conferenceDetails: action.conferenceDetails,
        startDate: action.conferenceDetails.start_date
          ? action.conferenceDetails.start_date
          : {}
      })
    case SCHEDULE_SUBMITTED:
      return Object.assign({}, state, {
        scheduleUpdated: action.scheduleUpdated
      })
    case SERVER_ERROR_OCURED:
      return Object.assign({}, state, {
        serverError: true
      })
    default:
      return state
  }
}

export default roomReducer



// WEBPACK FOOTER //
// ./src/routes/Room/reducer.js